import { MiTHEME } from "@miplatform/theme";
import { WorkOrderStatus, WorkOrderSubStatus } from "@miplatform/types";
import { ICONS_NATIVE_STATUS, ICONS_WEB } from "../icons/icons";

export const ATTEMPT_STATUSES = {
  NEW: "New",
  PLANNED: "Planned",
  ENROUTE: "Enroute",
  HOLD: "Hold",
  DISPATCHED: "Dispatched",
  STARTED: "Started",
  SUBMITTED: "Submitted",
  CLOSEOUT_IN_PROGRESS: "CloseoutInProgress",
  CLOSED: "Closed",
  CANCELLED: "Cancelled",
  PENDING: "Pending",
};

export const ATTEMPT_DERIVED_STATUS = {
  NEW: "New",
  SCHEDULED: "Scheduled",
  DISPATCHED: "Dispatched",
  ENROUTE: "Enroute",
  STARTED: "Started",
  JOB_COMPLETE: "JobComplete",
  JOB_INCOMPLETE: "JobIncomplete",
  PENDING_CLOSEOUT: "PendingCloseout",
  PENDING_PREBILL: "PendingPrebill",
  CLOSEOUT_CLOSED: "CloseoutClosed",
  PENDING_INVOICING: "PendingInvoicing",
  INVOICED: "Invoiced",
  CANCELLED: "Cancelled",
  ON_HOLD: "OnHold",
  UNABLE_TO_START: "UnableToStart",
  PENDING_REVIEW: "PendingReview",
  VERIFICATION_COMPLETED: "VerificationCompleted",
};

export const ATTEMPT_DERIVED_STATUS_LABEL = {
  [ATTEMPT_DERIVED_STATUS.NEW]: "New",
  [ATTEMPT_DERIVED_STATUS.SCHEDULED]: "Scheduled",
  [ATTEMPT_DERIVED_STATUS.ENROUTE]: "Enroute",
  [ATTEMPT_DERIVED_STATUS.DISPATCHED]: "Dispatched",
  [ATTEMPT_DERIVED_STATUS.STARTED]: "Started",
  [ATTEMPT_DERIVED_STATUS.JOB_COMPLETE]: "Job Complete",
  [ATTEMPT_DERIVED_STATUS.JOB_INCOMPLETE]: "Job Incomplete",
  [ATTEMPT_DERIVED_STATUS.PENDING_CLOSEOUT]: "Pending Closeout",
  [ATTEMPT_DERIVED_STATUS.PENDING_PREBILL]: "Pending Pre-Bill",
  [ATTEMPT_DERIVED_STATUS.CLOSEOUT_CLOSED]: "Closeout Closed",
  [ATTEMPT_DERIVED_STATUS.PENDING_INVOICING]: "Pending Invoicing",
  [ATTEMPT_DERIVED_STATUS.INVOICED]: "Invoiced",
  [ATTEMPT_DERIVED_STATUS.CANCELLED]: "Cancelled",
  [ATTEMPT_DERIVED_STATUS.ON_HOLD]: "On Hold",
  [ATTEMPT_DERIVED_STATUS.UNABLE_TO_START]: "Cannot Perform",
  [undefined]: "N/A",
  [ATTEMPT_DERIVED_STATUS.PENDING_REVIEW]: "Pending Verification",
  [ATTEMPT_DERIVED_STATUS.VERIFICATION_COMPLETED]: "Verification Completed",
};

export const SUBMIT_STATUSES = {
  COMPLETE: "Complete",
  INCOMPLETE: "Incomplete",
  UNABLE_TO_START: "UnableToStart",
};

export const ATTEMPT_VIEW_STATUSES = {
  UNSCHEDULED: "Unscheduled",
  SCHEDULED: "Scheduled",
  CANNOT_START: "Cannot Start",
  ON_HOLD: "On Hold",
  IN_PROGRESS: "In Progress",
  CLOSING_OUT: "Closing Out",
  COMPLETE: "Complete",
  INCOMPLETE: "Incomplete",
  CANCELLED: "Cancelled",
};

export const OPTION_STATUS = {
  ADDED: "IsAdded",
  EXISTING: "IsExisting",
  REMOVED: "IsRemoved",
};

export const PLAN_CONFIG_STATUS = {
  ADDED: "IsAdded",
  EXISTING: "IsExisting",
  REMOVED: "IsRemoved",
};

export const AVAILABILITY_LOG_TYPE = {
  INACTIVE: "Inactive",
  STATUS_NOTE: "StatusNote",
};

export const ATTEMPT_VIEW_STATUSES_CONFIG = {
  [ATTEMPT_VIEW_STATUSES.UNSCHEDULED]: {
    color: MiTHEME.palette.grey.main,
    label: ATTEMPT_VIEW_STATUSES.UNSCHEDULED,
    backgroundColor: MiTHEME.palette.grey.light,
  },
  [ATTEMPT_VIEW_STATUSES.SCHEDULED]: {
    color: MiTHEME.palette.blue.main,
    label: ATTEMPT_VIEW_STATUSES.SCHEDULED,
    backgroundColor: MiTHEME.palette.blue.light,
  },
  [ATTEMPT_VIEW_STATUSES.CANNOT_START]: {
    color: MiTHEME.palette.purple.main,
    label: ATTEMPT_VIEW_STATUSES.CANNOT_START,
    backgroundColor: MiTHEME.palette.purple.light,
    icon: ICONS_NATIVE_STATUS.HOLD,
  },
  [ATTEMPT_VIEW_STATUSES.ON_HOLD]: {
    color: MiTHEME.palette.purple.main,
    label: ATTEMPT_VIEW_STATUSES.ON_HOLD,
    backgroundColor: MiTHEME.palette.purple.light,
    icon: ICONS_NATIVE_STATUS.HOLD,
  },
  [ATTEMPT_VIEW_STATUSES.IN_PROGRESS]: {
    color: MiTHEME.palette.orange.medium,
    label: ATTEMPT_VIEW_STATUSES.IN_PROGRESS,
    backgroundColor: MiTHEME.palette.amber.light,
    icon: ICONS_NATIVE_STATUS.INPROGRESS,
  },
  [ATTEMPT_VIEW_STATUSES.CLOSING_OUT]: {
    color: MiTHEME.palette.orange.medium,
    label: ATTEMPT_VIEW_STATUSES.CLOSING_OUT,
    backgroundColor: MiTHEME.palette.amber.light,
    icon: ICONS_NATIVE_STATUS.INPROGRESS,
  },
  [ATTEMPT_VIEW_STATUSES.COMPLETE]: {
    color: MiTHEME.palette.green.main,
    label: ATTEMPT_VIEW_STATUSES.COMPLETE,
    backgroundColor: MiTHEME.palette.green.light,
    icon: ICONS_NATIVE_STATUS.COMPLETED,
  },
  [ATTEMPT_VIEW_STATUSES.INCOMPLETE]: {
    color: MiTHEME.palette.red.main,
    label: ATTEMPT_VIEW_STATUSES.INCOMPLETE,
    backgroundColor: MiTHEME.palette.red.light,
    icon: ICONS_NATIVE_STATUS.INCOMPLETE,
  },
  [ATTEMPT_VIEW_STATUSES.CANCELLED]: {
    color: MiTHEME.palette.grey.main,
    label: ATTEMPT_VIEW_STATUSES.CANCELLED,
    backgroundColor: MiTHEME.palette.grey.light,
    icon: ICONS_NATIVE_STATUS.CANCELLED,
  },
};

export const ATTEMPT_STATUSES_LABELS = {
  [ATTEMPT_STATUSES.NEW]: "New",
  [ATTEMPT_STATUSES.PLANNED]: "Scheduled",
  [ATTEMPT_STATUSES.HOLD]: "Hold",
  [ATTEMPT_STATUSES.ENROUTE]: "Enroute",
  [ATTEMPT_STATUSES.DISPATCHED]: "Dispatched",
  [ATTEMPT_STATUSES.STARTED]: "Started",
  [ATTEMPT_STATUSES.SUBMITTED]: "Submitted",
  [ATTEMPT_STATUSES.CLOSEOUT_IN_PROGRESS]: "Pending Closeout",
  [ATTEMPT_STATUSES.CLOSED]: "Closed",
  [ATTEMPT_STATUSES.CANCELLED]: "Cancelled",
  [undefined]: "N/A",
};

export const ATTEMPT_STATUSES_ICONS = {
  [ATTEMPT_STATUSES.DISPATCHED]: {
    icon: ICONS_NATIVE_STATUS.DISPATCHED,
    color: MiTHEME.palette.bluegrey.main,
    backgroundColor: MiTHEME.palette.orange.light,
  },
  [ATTEMPT_STATUSES.PLANNED]: {
    icon: ICONS_NATIVE_STATUS.READY,
    color: MiTHEME.palette.blue.main,
    backgroundColor: MiTHEME.palette.blue.light,
  },
  [ATTEMPT_STATUSES.STARTED]: {
    icon: ICONS_NATIVE_STATUS.INPROGRESS,
    color: MiTHEME.palette.orange.main,
    backgroundColor: MiTHEME.palette.orange.light,
  },
  [ATTEMPT_STATUSES.SUBMITTED]: {
    icon: ICONS_NATIVE_STATUS.SUBMITTED,
    color: MiTHEME.palette.green.main,
    backgroundColor: MiTHEME.palette.green.light,
  },
  [ATTEMPT_STATUSES.NEW]: {
    icon: ICONS_NATIVE_STATUS.READY,
    color: MiTHEME.palette.grey.main,
    backgroundColor: MiTHEME.palette.grey.light,
  },
  [ATTEMPT_STATUSES.HOLD]: {
    icon: ICONS_NATIVE_STATUS.HOLD,
    color: MiTHEME.palette.purple.main,
    backgroundColor: MiTHEME.palette.purple.light,
  },
  [ATTEMPT_STATUSES.CLOSED]: {
    icon: ICONS_NATIVE_STATUS.CLOSED,
    color: MiTHEME.palette.red.dark,
    backgroundColor: MiTHEME.palette.red.light,
  },
  [ATTEMPT_STATUSES.CLOSEOUT_IN_PROGRESS]: {
    icon: ICONS_NATIVE_STATUS.CLOSEOUT_INPROGRESS,
    color: MiTHEME.palette.orange.dark,
    backgroundColor: MiTHEME.palette.orange.light,
  },
};

export const TASK_STATUSES = {
  NEW: "New",
  WORK_COMPLETE: "WorkComplete",
  FAILED: "Failed",
  VERIFIED: "Verified",
  IN_PROGRESS: "InProgress",
  FINALIZED: "Finalized",
  CANCELLED: "Cancelled",
};

export const TASK_STATUSES_LABELS = {
  [TASK_STATUSES.NEW]: "Not Started",
  [TASK_STATUSES.IN_PROGRESS]: "In Progress",
  [TASK_STATUSES.WORK_COMPLETE]: "Complete",
  [TASK_STATUSES.CANCELLED]: "Cancelled",
  [SUBMIT_STATUSES.COMPLETE]: "Complete",
  [SUBMIT_STATUSES.INCOMPLETE]: "Incomplete",
};

export const TASK_STATUSES_CONFIG = {
  [TASK_STATUSES.NEW]: {
    color: MiTHEME.palette.blue.dark,
    label: TASK_STATUSES_LABELS[TASK_STATUSES.NEW],
    backgroundColor: MiTHEME.palette.blue.light,
    icon: ICONS_NATIVE_STATUS.NEW_TASK,
  },
  [TASK_STATUSES.WORK_COMPLETE]: {
    color: MiTHEME.palette.green.main,
    label: TASK_STATUSES_LABELS[TASK_STATUSES.WORK_COMPLETE],
    backgroundColor: MiTHEME.palette.green.light,
    icon: ICONS_NATIVE_STATUS.WORK_COMPLETE,
  },
  [TASK_STATUSES.IN_PROGRESS]: {
    color: MiTHEME.palette.orange.main,
    label: TASK_STATUSES_LABELS[TASK_STATUSES.IN_PROGRESS],
    backgroundColor: MiTHEME.palette.amber.light,
    icon: ICONS_NATIVE_STATUS.INPROGRESS,
  },
  [SUBMIT_STATUSES.INCOMPLETE]: {
    color: MiTHEME.palette.red.main,
    label: TASK_STATUSES_LABELS[SUBMIT_STATUSES.INCOMPLETE],
    backgroundColor: MiTHEME.palette.red.light,
    icon: ICONS_NATIVE_STATUS.INCOMPLETE,
  },
  [SUBMIT_STATUSES.COMPLETE]: {
    color: MiTHEME.palette.green.main,
    label: TASK_STATUSES_LABELS[SUBMIT_STATUSES.COMPLETE],
    backgroundColor: MiTHEME.palette.green.light,
    icon: ICONS_NATIVE_STATUS.COMPLETED,
  },
};

export const SUBMIT_STATUSES_LABELS = {
  [SUBMIT_STATUSES.COMPLETE]: "Complete",
  [SUBMIT_STATUSES.INCOMPLETE]: "Incomplete",
  [SUBMIT_STATUSES.UNABLE_TO_START]: "Cannot Start",
};

export const SUBMIT_STATUSES_ICONS = {
  [SUBMIT_STATUSES.COMPLETE]: {
    icon: ICONS_NATIVE_STATUS.COMPLETED,
    color: MiTHEME.palette.green.main,
    backgroundColor: MiTHEME.palette.green.light,
  },
  [SUBMIT_STATUSES.INCOMPLETE]: {
    icon: ICONS_NATIVE_STATUS.INCOMPLETE,
    color: MiTHEME.palette.red.dark,
    backgroundColor: MiTHEME.palette.red.light,
  },
  [SUBMIT_STATUSES.UNABLE_TO_START]: {
    icon: ICONS_NATIVE_STATUS.UNABLE_TO_START,
    color: MiTHEME.palette.purple.dark,
    backgroundColor: MiTHEME.palette.purple.light,
  },
};

export const TASK_RESULT_STATUSES = {
  IN_PROGRESS: "InProgress",
  PAUSED: "Paused",
  SUBMITTED: "Submitted",
  CANCELLED: "Cancelled",
};

export const TASK_STATUS_KEYED = {
  [TASK_STATUSES.NEW]: {
    label: "New",
    color: MiTHEME.palette.orange.main,
    backgroundColor: MiTHEME.palette.orange.light,
    iconWeb: ICONS_WEB.MINUS_BOX,
  },
  [TASK_STATUSES.IN_PROGRESS]: {
    label: "In Progress",
    color: MiTHEME.palette.orange.main,
    backgroundColor: MiTHEME.palette.orange.light,
    iconWeb: ICONS_WEB.CLOCK_OUTLINE,
  },
  [TASK_STATUSES.CANCELLED]: {
    label: "Cancelled",
    color: MiTHEME.palette.grey.main,
    backgroundColor: MiTHEME.palette.grey.lightAccent,
    iconWeb: ICONS_WEB.CANCEL,
  },
  [TASK_RESULT_STATUSES.PAUSED]: {
    label: "Paused",
    color: MiTHEME.palette.grey.main,
    backgroundColor: MiTHEME.palette.grey.light,
    iconWeb: ICONS_WEB.PAUSED,
  },
  [SUBMIT_STATUSES.COMPLETE]: {
    label: "Complete",
    color: MiTHEME.palette.green.main,
    backgroundColor: MiTHEME.palette.green.light,
    iconWeb: ICONS_WEB.CHECKBOX_MARKED,
  },
  [SUBMIT_STATUSES.INCOMPLETE]: {
    label: "Incomplete",
    color: MiTHEME.palette.red.dark,
    backgroundColor: MiTHEME.palette.red.light,
    iconWeb: ICONS_WEB.CLOSE_BOX,
  },
  [TASK_STATUSES.FINALIZED]: {
    label: "Finalized",
    color: MiTHEME.palette.green.main,
    backgroundColor: MiTHEME.palette.green.light,
    iconWeb: ICONS_WEB.CHECK_ALL,
  },
  [TASK_STATUSES.WORK_COMPLETE]: {
    label: "WorkComplete",
    color: MiTHEME.palette.green.main,
    backgroundColor: MiTHEME.palette.green.light,
    iconWeb: ICONS_WEB.CHECK_ALL,
  },
  [TASK_RESULT_STATUSES.FAILED]: {
    label: "Failed",
    color: MiTHEME.palette.red.dark,
    backgroundColor: MiTHEME.palette.red.light,
    iconWeb: ICONS_WEB.CLOSE_BOX,
  },
  [TASK_RESULT_STATUSES.VERIFIED]: {
    label: "Verified",
    color: MiTHEME.palette.orange.main,
    backgroundColor: MiTHEME.palette.orange.light,
    iconWeb: ICONS_WEB.CLOCK_OUTLINE,
  },
};

export const TECHNICIAN_AVAILABAILITY_STATUSES = {
  AVAILABLE: "Available",
  UNAVAILABLE: "Unavailable",
  ON_CALL: "OnCall",
};

export const TECHNICIAN_AVAILABAILITY_STATUSES_KEYED = {
  [TECHNICIAN_AVAILABAILITY_STATUSES.AVAILABLE]: {
    value: TECHNICIAN_AVAILABAILITY_STATUSES.AVAILABLE,
    icon: ICONS_WEB.CHECK,
    color: MiTHEME.palette.green.main,
    label: "Available",
  },
  [TECHNICIAN_AVAILABAILITY_STATUSES.UNAVAILABLE]: {
    value: TECHNICIAN_AVAILABAILITY_STATUSES.UNAVAILABLE,
    icon: ICONS_WEB.CLOSE,
    color: MiTHEME.palette.red.medium,
    label: "Unavailable",
  },
  [TECHNICIAN_AVAILABAILITY_STATUSES.ON_CALL]: {
    value: TECHNICIAN_AVAILABAILITY_STATUSES.ON_CALL,
    icon: ICONS_WEB.PHONE,
    color: MiTHEME.palette.green.main,
    label: "On Call",
  },
};

export const TECHNICIAN_ACTIVITY_STATUSES = {
  IDLE: "Idle",
  EN_ROUTE: "EnRoute",
  ON_SITE: "OnSite",
  ON_BREAK: "OnBreak",
};

export const TECHNICIAN_ACTIVITY_STATUSES_KEYED = {
  [TECHNICIAN_ACTIVITY_STATUSES.IDLE]: {
    value: TECHNICIAN_ACTIVITY_STATUSES.IDLE,
    icon: ICONS_WEB.CIRCLE_SLICE,
    color: MiTHEME.palette.grey.medium,
    label: "Idle",
  },
  [TECHNICIAN_ACTIVITY_STATUSES.ON_SITE]: {
    value: TECHNICIAN_ACTIVITY_STATUSES.ON_SITE,
    icon: ICONS_WEB.CLOCK_TIME_FIVE_OUTLINE,
    color: MiTHEME.palette.orange.main,
    label: "On Site",
  },
  [TECHNICIAN_ACTIVITY_STATUSES.EN_ROUTE]: {
    value: TECHNICIAN_ACTIVITY_STATUSES.EN_ROUTE,
    icon: ICONS_WEB.CAR_ESTATE,
    color: MiTHEME.palette.yellow.dark,
    label: "En Route",
  },
  [TECHNICIAN_ACTIVITY_STATUSES.ON_BREAK]: {
    value: TECHNICIAN_ACTIVITY_STATUSES.ON_BREAK,
    icon: ICONS_WEB.TIMER_SAND,
    color: MiTHEME.palette.blue.main,
    label: "On Break",
  },
};

export const TECHNICIAN_STATUSES = {
  ...TECHNICIAN_ACTIVITY_STATUSES,
  ...TECHNICIAN_AVAILABAILITY_STATUSES,
  CLOCKED_OUT: "ClockedOut",
  STAND_BY: "StandBy",
  ON_CALL_ON_ROUTE_HOME: "OnCallOnRouteHome",
  ON_CALL_ON_SITE: "OnCallOnSite",
  ON_CALL_ENROUTE_JOB: "OnCallEnrouteJob",
};

export const TECHNICIAN_STATUSES_KEYED = {
  [TECHNICIAN_STATUSES.CLOCKED_OUT]: {
    icon: ICONS_WEB.MINUS_CIRCLE,
    color: MiTHEME.palette.grey.medium,
    label: "Clocked Out",
  },
  // NOTE: waiting for standby/oncallroutehome/oncallonsite/oncallenroutejob icon/color from harshal
  [TECHNICIAN_STATUSES.STAND_BY]: {
    icon: ICONS_WEB.HELP_CIRCLE,
    color: MiTHEME.palette.grey.medium,
    label: "Stand By",
  },
  [TECHNICIAN_STATUSES.ON_CALL_ON_ROUTE_HOME]: {
    icon: ICONS_WEB.HELP_CIRCLE,
    color: MiTHEME.palette.grey.medium,
    label: "On-Call/ En Route /Home",
  },
  [TECHNICIAN_STATUSES.ON_CALL_ON_SITE]: {
    icon: ICONS_WEB.HELP_CIRCLE,
    color: MiTHEME.palette.grey.medium,
    label: "On-Call/ On-Site",
  },
  [TECHNICIAN_STATUSES.ON_CALL_ENROUTE_JOB]: {
    icon: ICONS_WEB.HELP_CIRCLE,
    color: MiTHEME.palette.grey.medium,
    label: "On-Call/En Route / Job",
  },
};

export const USER_ACTIVITY_STATUSES = {
  ACTIVE: "Active",
  PENDING: "Pending",
};

export const ISSUE_STATUSES = {
  REPORTED: "Reported",
  CONFIRMED: "Confirmed",
  CLOSED: "Closed",
  CANCELLED: "Cancelled",
  INPROGRESS: "InProgress",
  NOT_CREATED: "NOT_CREATED", // Status unique to frontend for issues that are not created
};

export const ISSUE_STATUSES_KEYED = {
  [ISSUE_STATUSES.NOT_CREATED]: {
    label: "Not Started",
    iconWeb: ICONS_WEB.TOOLS,
  },
  [ISSUE_STATUSES.REPORTED]: {
    label: "New",
    color: MiTHEME.palette.orange.main,
    backgroundColor: MiTHEME.palette.orange.light,
    iconWeb: ICONS_WEB.MINUS_BOX,
  },
  [ISSUE_STATUSES.INPROGRESS]: {
    label: "In Progress",
    color: MiTHEME.palette.caution.dark,
    backgroundColor: MiTHEME.palette.yellow.light,
    iconWeb: ICONS_WEB.CLOCK_OUTLINE,
  },
  [ISSUE_STATUSES.CONFIRMED]: {
    label: "Incomplete",
    color: MiTHEME.palette.red.dark,
    backgroundColor: MiTHEME.palette.red.light,
    iconWeb: ICONS_WEB.CLOSE_BOX,
  },
  [ISSUE_STATUSES.CANCELLED]: {
    label: "Cancelled",
    color: MiTHEME.palette.grey.main,
    backgroundColor: MiTHEME.palette.grey.lightAccent,
    iconWeb: ICONS_WEB.CANCEL,
  },
  [ISSUE_STATUSES.CLOSED]: {
    label: "Completed",
    color: MiTHEME.palette.green.main,
    backgroundColor: MiTHEME.palette.green.light,
    iconWeb: ICONS_WEB.CHECKBOX_MARKED,
  },
};

export const ISSUE_RELATIONSHIP_TYPES = {
  REPORTED_ON: "ReportedOn",
  RESOLVED_BY: "ResolvedBy",
  CAUSED_BY: "CausedBy",
  BLOCKS: "Blocks",
  DEFECT: "Defect",
};

export const ISSUE_RELATIONSHIP_ENTITY_TYPES = {
  ASSIGNMENTS: "assignments",
  ATTEMPTS: "attempts",
  STEPS: "steps",
};

export const INSPECTION_STATUSES = {
  SCHEDULED: "Scheduled",
  READY: "Ready",
  PENDING: "Pending",
  PASSED: "Passed",
  FAILED: "Failed",
  CANCELLED: "Cancelled",
  RESCHEDULED: "Rescheduled",
};

export const INSPECTION_STATUSES_CONFIG = {
  [INSPECTION_STATUSES.SCHEDULED]: {
    color: MiTHEME.palette.blue.main,
    label: "Sched",
    backgroundColor: MiTHEME.palette.blue.light,
  },
  [INSPECTION_STATUSES.READY]: {
    color: MiTHEME.palette.blue.main,
    label: INSPECTION_STATUSES.READY,
    backgroundColor: MiTHEME.palette.blue.light,
  },
  [INSPECTION_STATUSES.PENDING]: {
    color: MiTHEME.palette.warning.main,
    label: INSPECTION_STATUSES.PENDING,
    backgroundColor: MiTHEME.palette.warning.light,
  },
  [INSPECTION_STATUSES.PASSED]: {
    color: MiTHEME.palette.green.main,
    label: INSPECTION_STATUSES.PASSED,
    backgroundColor: MiTHEME.palette.green.light,
    cardBackgroundColor: MiTHEME.palette.green.light,
    cardBorderColor: MiTHEME.palette.green.main,
  },
  [INSPECTION_STATUSES.FAILED]: {
    color: MiTHEME.palette.red.main,
    label: INSPECTION_STATUSES.FAILED,
    backgroundColor: MiTHEME.palette.red.light,
    cardBackgroundColor: MiTHEME.palette.red.light,
    cardBorderColor: MiTHEME.palette.red.main,
  },
  [INSPECTION_STATUSES.CANCELLED]: {
    color: MiTHEME.palette.grey.main,
    label: INSPECTION_STATUSES.CANCELLED,
    backgroundColor: MiTHEME.palette.grey.light,
  },
  [INSPECTION_STATUSES.RESCHEDULED]: {
    color: MiTHEME.palette.purple.main,
    label: INSPECTION_STATUSES.RESCHEDULED,
    backgroundColor: MiTHEME.palette.purple.light,
  },
};

export const ORDER_STATUS = {
  NEW: "New",
  APPROVED: "Approved",
  RESCHEDULED: "Rescheduled",
  HOLD: "Hold",
  FOLLOW_UP: "FollowUp",
  CONFIRMED: "Confirmed",
  ASSIGNED: "Assigned",
  IN_PROGRESS: "InProgress",
  COMPLETE: "Complete",
  CANCELLED: "Cancelled",
};

export const ORDER_STATUS_DISPLAY = {
  [ORDER_STATUS.NEW]: "New",
  [ORDER_STATUS.APPROVED]: "Approved",
  [ORDER_STATUS.RESCHEDULED]: "Rescheduled",
  [ORDER_STATUS.HOLD]: "Hold",
  [ORDER_STATUS.CONFIRMED]: "Confirmed",
  [ORDER_STATUS.ASSIGNED]: "Assigned",
  [ORDER_STATUS.IN_PROGRESS]: "In Progress",
  [ORDER_STATUS.COMPLETE]: "Complete",
  [ORDER_STATUS.CANCELLED]: "Cancelled",
};

export const ORDER_STATUS_COLORS = {
  [ORDER_STATUS.NEW]: MiTHEME.palette.orange.main,
  [ORDER_STATUS.APPROVED]: MiTHEME.palette.blue.main,
  [ORDER_STATUS.RESCHEDULED]: MiTHEME.palette.grey.main,
  [ORDER_STATUS.HOLD]: MiTHEME.palette.purple.dark,
  [ORDER_STATUS.CONFIRMED]: MiTHEME.palette.blue.dark,
  [ORDER_STATUS.ASSIGNED]: MiTHEME.palette.yellow.medium,
  [ORDER_STATUS.IN_PROGRESS]: MiTHEME.palette.yellow.main,
  [ORDER_STATUS.COMPLETE]: MiTHEME.palette.green.main,
  [ORDER_STATUS.CANCELLED]: MiTHEME.palette.red.accent,
};
export const ORDER_STATUS_TITLE_COLORS = {
  [ORDER_STATUS.NEW]: MiTHEME.palette.red.dark,
  [ORDER_STATUS.APPROVED]: MiTHEME.palette.blue.dark,
  [ORDER_STATUS.RESCHEDULED]: MiTHEME.palette.grey.dark,
  [ORDER_STATUS.HOLD]: MiTHEME.palette.deepPurple.darkAccent,
  [ORDER_STATUS.CONFIRMED]: MiTHEME.palette.blue.dark,
  [ORDER_STATUS.ASSIGNED]: MiTHEME.palette.yellow.dark,
  [ORDER_STATUS.IN_PROGRESS]: MiTHEME.palette.yellow.dark,
  [ORDER_STATUS.COMPLETE]: MiTHEME.palette.green.main,
  [ORDER_STATUS.CANCELLED]: MiTHEME.palette.red.dark,
};

export const ORDER_STATUS_BORDER_COLORS = {
  [ORDER_STATUS.NEW]: MiTHEME.palette.red.dark,
  [ORDER_STATUS.APPROVED]: MiTHEME.palette.blue.dark,
  [ORDER_STATUS.RESCHEDULED]: MiTHEME.palette.grey.darkAccent,
  [ORDER_STATUS.HOLD]: MiTHEME.palette.deepPurple.darkAccent,
  [ORDER_STATUS.CONFIRMED]: MiTHEME.palette.blue.dark,
  [ORDER_STATUS.ASSIGNED]: MiTHEME.palette.yellow.medium,
  [ORDER_STATUS.IN_PROGRESS]: MiTHEME.palette.yellow.medium,
  [ORDER_STATUS.COMPLETE]: MiTHEME.palette.green.main,
  [ORDER_STATUS.CANCELLED]: MiTHEME.palette.red.dark,
};

export const ORDER_STATUS_COLORS_MAP = {
  [ORDER_STATUS.NEW]: {
    color: ORDER_STATUS_TITLE_COLORS[ORDER_STATUS.NEW],
    label: ORDER_STATUS_DISPLAY[ORDER_STATUS.NEW],
    backgroundColor: `${ORDER_STATUS_COLORS[ORDER_STATUS.NEW]}2A`,
  },
  [ORDER_STATUS.APPROVED]: {
    color: ORDER_STATUS_TITLE_COLORS[ORDER_STATUS.APPROVED],
    label: ORDER_STATUS_DISPLAY[ORDER_STATUS.APPROVED],
    backgroundColor: `${ORDER_STATUS_COLORS[ORDER_STATUS.APPROVED]}2A`,
  },
  [ORDER_STATUS.RESCHEDULED]: {
    color: ORDER_STATUS_TITLE_COLORS[ORDER_STATUS.RESCHEDULED],
    label: ORDER_STATUS_DISPLAY[ORDER_STATUS.RESCHEDULED],
    backgroundColor: `${ORDER_STATUS_COLORS[ORDER_STATUS.RESCHEDULED]}2A`,
  },
  [ORDER_STATUS.HOLD]: {
    color: ORDER_STATUS_TITLE_COLORS[ORDER_STATUS.HOLD],
    label: ORDER_STATUS_DISPLAY[ORDER_STATUS.HOLD],
    backgroundColor: `${ORDER_STATUS_COLORS[ORDER_STATUS.HOLD]}2A`,
  },
  [ORDER_STATUS.CONFIRMED]: {
    color: ORDER_STATUS_TITLE_COLORS[ORDER_STATUS.CONFIRMED],
    label: ORDER_STATUS_DISPLAY[ORDER_STATUS.CONFIRMED],
    backgroundColor: `${ORDER_STATUS_COLORS[ORDER_STATUS.CONFIRMED]}2A`,
  },
  [ORDER_STATUS.ASSIGNED]: {
    color: ORDER_STATUS_TITLE_COLORS[ORDER_STATUS.ASSIGNED],
    label: ORDER_STATUS_DISPLAY[ORDER_STATUS.ASSIGNED],
    backgroundColor: `${ORDER_STATUS_COLORS[ORDER_STATUS.ASSIGNED]}2A`,
  },
  [ORDER_STATUS.IN_PROGRESS]: {
    color: ORDER_STATUS_TITLE_COLORS[ORDER_STATUS.IN_PROGRESS],
    label: ORDER_STATUS_DISPLAY[ORDER_STATUS.IN_PROGRESS],
    backgroundColor: `${ORDER_STATUS_COLORS[ORDER_STATUS.IN_PROGRESS]}2A`,
  },
  [ORDER_STATUS.COMPLETE]: {
    color: ORDER_STATUS_TITLE_COLORS[ORDER_STATUS.COMPLETE],
    label: ORDER_STATUS_DISPLAY[ORDER_STATUS.COMPLETE],
    backgroundColor: `${ORDER_STATUS_COLORS[ORDER_STATUS.COMPLETE]}2A`,
  },
  [ORDER_STATUS.CANCELLED]: {
    color: ORDER_STATUS_TITLE_COLORS[ORDER_STATUS.CANCELLED],
    label: ORDER_STATUS_DISPLAY[ORDER_STATUS.CANCELLED],
    backgroundColor: `${ORDER_STATUS_COLORS[ORDER_STATUS.CANCELLED]}2A`,
  },
};

export const WORK_ORDER_STATUSES = {
  NEW: "New",
  PENDING: "Pending",
  IN_PROGRESS: "InProgress",
  HOLD: "Hold",
  COMPLETE: "Complete",
  CANCELLED: "Cancelled",
};

export const WORK_ORDER_STATUSES_DISPLAY = {
  [WORK_ORDER_STATUSES.NEW]: "New",
  [WORK_ORDER_STATUSES.PENDING]: "Pending",
  [WORK_ORDER_STATUSES.IN_PROGRESS]: "In Progress",
  [WORK_ORDER_STATUSES.HOLD]: "Hold",
  [WORK_ORDER_STATUSES.COMPLETE]: "Complete",
  [WORK_ORDER_STATUSES.CANCELLED]: "Cancelled",
};

export const WORK_ORDER_STATUS_COLORS = {
  [WORK_ORDER_STATUSES.NEW]: MiTHEME.palette.orange.main,
  [WORK_ORDER_STATUSES.PENDING]: MiTHEME.palette.blue.main,
  [WORK_ORDER_STATUSES.IN_PROGRESS]: MiTHEME.palette.grey.main,
  [WORK_ORDER_STATUSES.HOLD]: MiTHEME.palette.purple.dark,
  [WORK_ORDER_STATUSES.COMPLETE]: MiTHEME.palette.blue.dark,
  [WORK_ORDER_STATUSES.CANCELLED]: MiTHEME.palette.red.accent,
};

export const WORK_ORDER_STATUSES_LABELS = {
  [WorkOrderStatus.New]: "New",
  [WorkOrderStatus.Assigned]: "Assigned",
  [WorkOrderStatus.Unassigned]: "Unassigned",
  [WorkOrderStatus.Reassigned]: "Re-Assigned",
  [WorkOrderStatus.Cancelled]: "Cancelled",
  [WorkOrderStatus.Complete]: "Complete",
  [WorkOrderStatus.InProgress]: "In Progress",
  [WorkOrderStatus.Hold]: "Hold",
  [WorkOrderStatus.HoldPreviousDay]: "Hold (Previous Day)",
  [WorkOrderStatus.Incomplete]: "Incomplete",
  [WorkOrderStatus.NotReady]: "Not Ready",
};

export const WORK_ORDER_SUBSTATUSES_LABELS = {
  [WorkOrderSubStatus.AtRisk]: "At Risk",
  [WorkOrderSubStatus.Late]: "Late",
  [WorkOrderSubStatus.Released]: "Released",
  [WorkOrderSubStatus.UnableToBeAutoAssigned]: "Unable to Auto-Assign",
};

export const WORK_ORDER_SUBSTATUSES = {
  LATE: "Late",
  AT_RISK: "At Risk",
  COMPLETE: "Complete",
};

export const WORK_ORDER_COLORS_MAP = {
  [WorkOrderStatus.New]: {
    main: MiTHEME.palette.grey.main,
    drawerStatus: MiTHEME.palette.grey.main,
    drawerStatusBackground: `${MiTHEME.palette.grey.light}2A`,
    drawerBackground: `${MiTHEME.palette.grey.light}1A`,
    cardBackgroundColor: MiTHEME.palette.common.white,
    drawerBorderColor: MiTHEME.palette.grey.darkAccent,
    borderColor: MiTHEME.palette.grey.darkAccent,
    borderStyle: "solid",
  },
  [WorkOrderStatus.Assigned]: {
    main: MiTHEME.palette.grey.main,
    drawerStatus: MiTHEME.palette.grey.main,
    drawerStatusBackground: `${MiTHEME.palette.grey.light}2A`,
    drawerBackground: `${MiTHEME.palette.grey.light}1A`,
    cardBackgroundColor: MiTHEME.palette.common.white,
    drawerBorderColor: MiTHEME.palette.grey.darkAccent,
    borderColor: MiTHEME.palette.grey.darkAccent,
    borderStyle: "solid",
  },
  [WorkOrderStatus.Unassigned]: {
    main: MiTHEME.palette.warning.main,
    drawerStatus: MiTHEME.palette.warning.main,
    drawerStatusBackground: `${MiTHEME.palette.warning.main}2A`,
    drawerBackground: MiTHEME.palette.warning.light,
    drawerBorderColor: MiTHEME.palette.warning.main,
    cardBackgroundColor: MiTHEME.palette.warning.light,
    cardBorderColor: MiTHEME.palette.warning.main,
    borderColor: MiTHEME.palette.warning.main,
    borderStyle: "dashed",
  },
  [WorkOrderStatus.Reassigned]: {
    cardBackgroundColor: MiTHEME.palette.blue.lightAccent,
    main: MiTHEME.palette.blue.main,
    title: MiTHEME.palette.blue.dark,
    drawerStatus: MiTHEME.palette.blue.main,
    drawerStatusBackground: `${MiTHEME.palette.blue.main}2A`,
    drawerBackground: `${MiTHEME.palette.blue.main}1A`,
    drawerBorderColor: MiTHEME.palette.blue.main,
    borderStyle: "solid",
    borderColor: MiTHEME.palette.grey.darkAccent,
  },
  [WorkOrderStatus.HoldPreviousDay]: {
    main: MiTHEME.palette.purple.dark,
    cardBackgroundColor: MiTHEME.palette.hold.light,
    cardTextColor: MiTHEME.palette.common.white,
    drawerStatus: MiTHEME.palette.purple.dark,
    drawerStatusBackground: `${MiTHEME.palette.purple.dark}2A`,
    drawerBackground: `${MiTHEME.palette.purple.dark}1A`,
    drawerBorderColor: MiTHEME.palette.purple.dark,
    borderStyle: "solid",
  },
  [WorkOrderStatus.Hold]: {
    main: MiTHEME.palette.purple.dark,
    cardBackgroundColor: MiTHEME.palette.hold.light,
    cardTextColor: MiTHEME.palette.common.white,
    drawerStatus: MiTHEME.palette.purple.dark,
    drawerStatusBackground: `${MiTHEME.palette.purple.dark}2A`,
    drawerBackground: `${MiTHEME.palette.purple.dark}1A`,
    drawerBorderColor: MiTHEME.palette.purple.dark,
    borderStyle: "solid",
    borderColor: MiTHEME.palette.grey.darkAccent,
  },
  [WorkOrderStatus.InProgress]: {
    main: MiTHEME.palette.yellow.main,
    cardBackgroundColor: MiTHEME.palette.yellow.accent,
    drawerStatus: MiTHEME.palette.caution.dark,
    drawerStatusBackground: `${MiTHEME.palette.yellow.main}2A`,
    drawerBackground: `${MiTHEME.palette.yellow.main}1A`,
    drawerBorderColor: MiTHEME.palette.caution.dark,
    borderStyle: "solid",
    borderColor: MiTHEME.palette.grey.darkAccent,
  },
  [WorkOrderStatus.Incomplete]: {
    main: MiTHEME.palette.error.main,
    drawerStatus: MiTHEME.palette.error.main,
    drawerStatusBackground: `${MiTHEME.palette.error.main}2A`,
    drawerBackground: `${MiTHEME.palette.error.main}1A`,
    cardBackgroundColor: MiTHEME.palette.error.light,
    drawerBorderColor: MiTHEME.palette.error.main,
    borderStyle: "solid",
    borderColor: MiTHEME.palette.grey.darkAccent,
  },
  [WorkOrderStatus.Complete]: {
    main: MiTHEME.palette.green.main,
    cardBackgroundColor: MiTHEME.palette.green.light,
    drawerStatus: MiTHEME.palette.green.main,
    drawerStatusBackground: `${MiTHEME.palette.green.main}2A`,
    drawerBackground: MiTHEME.palette.green.light,
    drawerBorderColor: MiTHEME.palette.green.main,
    borderStyle: "solid",
    borderColor: MiTHEME.palette.grey.darkAccent,
  },
  [WorkOrderStatus.Cancelled]: {
    main: MiTHEME.palette.error.main,
    drawerStatus: MiTHEME.palette.error.main,
    drawerStatusBackground: `${MiTHEME.palette.error.main}2A`,
    drawerBackground: `${MiTHEME.palette.error.main}1A`,
    cardBackgroundColor: MiTHEME.palette.error.light,
    drawerBorderColor: MiTHEME.palette.error.main,
    borderStyle: "solid",
    borderColor: MiTHEME.palette.grey.darkAccent,
  },
  [WorkOrderStatus.NotReady]: {
    main: MiTHEME.palette.grey.main,
    cardBackgroundColor: MiTHEME.palette.grey.light,
    drawerStatus: MiTHEME.palette.grey.main,
    drawerStatusBackground: `${MiTHEME.palette.grey.light}2A`,
    drawerBackground: `${MiTHEME.palette.grey.light}1A`,
    drawerBorderColor: MiTHEME.palette.grey.darkAccent,
    borderStyle: "solid",
    borderColor: MiTHEME.palette.grey.darkAccent,
  },
};

export const WORK_ORDER_HOVER_STATUS_MAP = {
  [WorkOrderStatus.New]: {
    background: MiTHEME.palette.grey.mediumLight,
    main: MiTHEME.palette.grey.darkAccent,
    text: MiTHEME.palette.common.black,
  },
  [WorkOrderStatus.Assigned]: {
    background: MiTHEME.palette.grey.mediumLight,
    main: MiTHEME.palette.grey.darkAccent,
    text: MiTHEME.palette.common.black,
  },
  [WorkOrderStatus.Unassigned]: {
    background: MiTHEME.palette.warning.light,
    main: MiTHEME.palette.warning.main,
  },
  [WorkOrderStatus.Reassigned]: {
    background: MiTHEME.palette.blue.light,
    main: MiTHEME.palette.blue.main,
  },
  [WorkOrderStatus.HoldPreviousDay]: {
    main: MiTHEME.palette.purple.dark,
    text: MiTHEME.palette.purple.darkAccent,
    background: `${MiTHEME.palette.purple.dark}2A`,
  },
  [WorkOrderStatus.Hold]: {
    main: MiTHEME.palette.purple.dark,
    text: MiTHEME.palette.purple.darkAccent,
    background: `${MiTHEME.palette.purple.dark}2A`,
  },
  [WorkOrderStatus.InProgress]: {
    main: MiTHEME.palette.yellow.main,
    text: MiTHEME.palette.caution.dark,
    background: `${MiTHEME.palette.yellow.main}2A`,
  },
  [WorkOrderStatus.Complete]: {
    main: MiTHEME.palette.green.main,
    text: MiTHEME.palette.green.dark,
    background: `${MiTHEME.palette.green.main}2A`,
  },
  [WorkOrderStatus.Incomplete]: {
    main: MiTHEME.palette.red.accent,
    text: MiTHEME.palette.red.dark,
    background: `${MiTHEME.palette.red.accent}2A`,
  },
  [WorkOrderStatus.Cancelled]: {
    main: MiTHEME.palette.red.accent,
    text: MiTHEME.palette.red.dark,
    background: `${MiTHEME.palette.red.accent}2A`,
  },
  [WorkOrderStatus.NotReady]: {
    main: MiTHEME.palette.grey.main,
    text: MiTHEME.palette.grey.dark,
    background: `${MiTHEME.palette.grey.main}2A`,
  },
};

export const WORK_ORDER_ABBR_STATUS_COLOR_MAP = {
  default: {
    background: MiTHEME.palette.grey.lightAccent,
    border: MiTHEME.palette.grey.darkAccent,
  },
  [WorkOrderStatus.Unassigned]: {
    background: MiTHEME.palette.warning.light,
    border: MiTHEME.palette.warning.main,
    label: WORK_ORDER_STATUSES_LABELS[WorkOrderStatus.Unassigned],
    status: {
      background: MiTHEME.palette.warning.main,
      border: MiTHEME.palette.warning.dark,
      text: MiTHEME.palette.common.white,
    },
  },
  [WorkOrderStatus.New]: {
    background: MiTHEME.palette.grey.lightAccent,
    border: MiTHEME.palette.grey.darkAccent,
    label: WORK_ORDER_STATUSES_LABELS[WorkOrderStatus.New],
  },
  [WorkOrderStatus.Assigned]: {
    background: MiTHEME.palette.grey.lightAccent,
    border: MiTHEME.palette.grey.darkAccent,
    label: WORK_ORDER_STATUSES_LABELS[WorkOrderStatus.Assigned],
  },
  [WorkOrderStatus.Reassigned]: {
    background: `${MiTHEME.palette.blue.main}2A`,
    border: MiTHEME.palette.blue.main,
    label: WORK_ORDER_STATUSES_LABELS[WorkOrderStatus.Reassigned],
    status: {
      background: MiTHEME.palette.blue.accent,
      border: MiTHEME.palette.blue.main,
      text: MiTHEME.palette.common.black,
    },
  },
  [WorkOrderStatus.InProgress]: {
    background: MiTHEME.palette.yellow.accent,
    border: MiTHEME.palette.yellow.dark,
    label: WORK_ORDER_STATUSES_LABELS[WorkOrderStatus.InProgress],
    status: {
      background: MiTHEME.palette.yellow.main,
      border: MiTHEME.palette.yellow.dark,
      text: MiTHEME.palette.common.black,
    },
  },
  [WorkOrderStatus.Hold]: {
    background: `${MiTHEME.palette.purple.dark}2A`,
    border: MiTHEME.palette.purple.dark,
    label: WORK_ORDER_STATUSES_LABELS[WorkOrderStatus.Hold],
    status: {
      background: MiTHEME.palette.purple.accent,
      border: MiTHEME.palette.purple.main,
      text: MiTHEME.palette.common.black,
    },
  },
  [WorkOrderStatus.Incomplete]: {
    background: MiTHEME.palette.error.light,
    border: MiTHEME.palette.error.main,
    label: WORK_ORDER_STATUSES_LABELS[WorkOrderStatus.Incomplete],
    status: {
      background: MiTHEME.palette.error.accent,
      border: MiTHEME.palette.error.main,
      text: MiTHEME.palette.common.white,
    },
  },
  [WorkOrderStatus.Cancelled]: {
    background: MiTHEME.palette.error.light,
    border: MiTHEME.palette.error.main,
    label: WORK_ORDER_STATUSES_LABELS[WorkOrderStatus.Cancelled],
    status: {
      background: MiTHEME.palette.error.accent,
      border: MiTHEME.palette.error.main,
      text: MiTHEME.palette.common.white,
    },
  },
  [WorkOrderStatus.Complete]: {
    background: MiTHEME.palette.grey.lightAccent,
    border: MiTHEME.palette.grey.darkAccent,
    label: WORK_ORDER_STATUSES_LABELS[WorkOrderStatus.Complete],
    status: {
      background: MiTHEME.palette.success.accent,
      border: MiTHEME.palette.success.main,
      text: MiTHEME.palette.common.white,
    },
  },
  [WorkOrderStatus.NotReady]: {
    background: MiTHEME.palette.grey.lightAccent,
    border: MiTHEME.palette.grey.darkAccent,
    label: WORK_ORDER_STATUSES_LABELS[WorkOrderStatus.NotReady],
  },
};

export const SCHEDULE_OFFSET_REFERENCES = {
  OrderApprovedStartDate: "OrderApprovedStartDate",
  OrderCompleteDate: "OrderCompleteDate",
};

export const SCHEDULE_OFFSET_REFERENCES_OPTIONS = [
  {
    label: "Approved Start Date",
    value: SCHEDULE_OFFSET_REFERENCES.OrderApprovedStartDate,
  },
  {
    label: "Complete Date",
    value: SCHEDULE_OFFSET_REFERENCES.OrderCompleteDate,
  },
];
